'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowsRotateReverseDot, iconArrowsRotateReverseDotTag } from '@ni/nimble-components/dist/esm/icons/arrows-rotate-reverse-dot';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowsRotateReverseDot };
export { iconArrowsRotateReverseDotTag };
export const NimbleIconArrowsRotateReverseDot = wrap(IconArrowsRotateReverseDot);